import { useSettingsDevStore } from '@/stores/settings/settings-dev.ts'
import { useSettingsTableStore } from '@/stores/settings/settings-table.ts'
import { useBoxPolicy } from '@/composables/box/box-policy.ts'
import type { AdminBox } from '@deepcloud/api-deep-box'

export function useBoxHiddenNodes(box: MaybeRefOrGetter<AdminBox | undefined>) {
  const settingsTableStore = useSettingsTableStore()
  const { isNodeViewHiddenNodesActive } = storeToRefs(settingsTableStore)
  const settingsDevStore = useSettingsDevStore()

  const { canListHiddenNodes } = useBoxPolicy()

  const canShowHiddenNodes = computed(() => {
    if (settingsDevStore.canModeFeature('BOX_VIEW_OPTION_HIDDEN_NODES')) {
      return isNodeViewHiddenNodesActive.value
    }

    const boxValue = toValue(box)
    if (!boxValue) return false

    return isNodeViewHiddenNodesActive.value && canListHiddenNodes(boxValue)
  })

  return { canShowHiddenNodes, isNodeViewHiddenNodesActive }
}
